import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import WhyUs from "./components/WhyUs";
import Courses from "./components/Courses";
import StudyAbroadBanner from "./components/StudyAbroadBanner";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import ContactCTA from "./components/ContactCTA";
import Footer from "./components/Footer";
import LeadModal from "./components/LeadModal";
import FloatingActions from "./components/FloatingActions";
import Location from "./components/Location";
import StudyAbroad from "./pages/StudyAbroad";

function useLeadModal() {
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState("");
  const openWith = (course = "") => {
    setPreselect(course);
    setOpen(true);
  };
  return { open, setOpen, preselect, openWith };
}

function Landing() {
  const { open, setOpen, preselect, openWith } = useLeadModal();

  return (
    <div className="App">
      <Navbar onEnroll={() => openWith()} />
      <Hero onEnroll={() => openWith()} />
      <Marquee />
      <WhyUs />
      <Courses onEnroll={(c) => openWith(c)} />
      <StudyAbroadBanner />
      <Testimonials />
      <FAQ />
      <ContactCTA onEnroll={() => openWith()} />
      <Location />
      <Footer />
      <FloatingActions />
      <LeadModal open={open} onClose={() => setOpen(false)} preselect={preselect} />
      <Toaster />
    </div>
  );
}

function StudyPage() {
  const { open, setOpen, preselect, openWith } = useLeadModal();
  return (
    <>
      <StudyAbroad onEnroll={() => openWith("Study in South Korea – Gimcheon University")} />
      <LeadModal open={open} onClose={() => setOpen(false)} preselect={preselect} />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/study-in-korea" element={<StudyPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
